module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main